<!--- 超时订单 --->
<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <shareParkingTree
        v-on:handleTreeClick="handleTreeClick"
        shareType="share"
        moduleName="parking"
      ></shareParkingTree>
    </div>
    <div class="right content-right list">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <!-- <div class="form-group">
            <label for>停车场:</label>

            <el-select
              class="space-parking"
              placeholder="请选择"
              clearable
              filterable
              v-model="search.parkingId"
            >
              <el-option
                v-for="{ parkingId, parkingName } in parks"
                :key="parkingId"
                :value="parkingId"
                :label="parkingName"
              ></el-option>
            </el-select>
          </div> -->
          <div class="form-group">
            <label for>车位号:</label>
            <input
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-model="search.uniqueId"
            />
          </div>
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-model="search.plateNumber"
            />
          </div>
          <div class="form-group">
            <label for>订单编号:</label>
            <input
              class="form-control"
              id
              type="text"
              placeholder
              size="15"
              v-model="search.orderNum"
            />
          </div>
          <div class="form-group">
            <label for>状态:</label>
            <el-select v-model="search.status">
              <el-option
                v-for="[key, value] in Object.entries(status)"
                :key="key"
                :value="key"
                :label="value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
        </form>
      </div>
      <!--左侧列表展示进出场记录-->
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-if="search.parkingId"
          v-loading="tableLoading"
        >
          <el-table-column
            show-overflow-tooltip
            label="停车场名称"
            prop="parkingName"
            width="200"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车位号"
            prop="uniqueId"
            width="120"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌号码"
            prop="plateNumber"
            :width="100"
          ></el-table-column>
 <el-table-column
            show-overflow-tooltip
            label="预约进场时间"
            prop="bookIn"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="预约出场时间"
            prop="bookOut"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="预约时长"
            prop="duration"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="进场时间"
            prop="actualIn"
            width="140"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.actualIn, "未进场") }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="出场时间"
            prop="actualOut"
            width="140"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.actualOut, "未出场") }}
            </template>
          </el-table-column>
              <el-table-column
            show-overflow-tooltip
            label="停放时长"
            prop="duration"
            width="120"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.duration, "-") }}
            </template>
          </el-table-column>
     <el-table-column
            show-overflow-tooltip
            label="超时时长"
            prop="timeoutDuration"
            width="120"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.duration, "-") }}
            </template>
          </el-table-column>
            <el-table-column
            show-overflow-tooltip
            label="取消时间"
            prop="cancelTime"
            width="140"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.cancelTime, "未取消") }}
            </template>
          </el-table-column>
            <el-table-column
            show-overflow-tooltip
            label="订单编号"
            prop="orderNum"
            width="190"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.orderNum, "-") }}
            </template>
          </el-table-column>
             <el-table-column show-overflow-tooltip label="停车总金额" prop="amount">
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.amount, "-", "", "元") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="订单金额" prop="amount">
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.amount, "-", "", "元") }}
            </template>
          </el-table-column>
           <el-table-column show-overflow-tooltip label="超时金额" prop="timeoutAmount">
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.amount, "-", "", "元") }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="已支付金额"
            prop="actualAmount"
            width="95"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.actualAmount, "-", "", "元") }}
            </template>
          </el-table-column>
        
      
          <el-table-column
            show-overflow-tooltip
            label="订单状态"
            prop="orderStatusText"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.orderStatusText, "-") }}
            </template>
          </el-table-column>

          <el-table-column label="支付次数" prop="payedCount" width="90">
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.payedCount, "-") }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="支付类型"
            prop="payTypeText"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.payTypeText, "-") }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="支付通道"
            prop="payChannelText"
            width="95"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.payChannelText, "-") }}
            </template>
          </el-table-column>

          <el-table-column show-overflow-tooltip label="操作" width="150px">
            <!-- <template slot-scope="scope">
              <button
                class="operate-button"
                @click="handleRecordDetail(scope.row)"
              >
                订单详情
              </button>
           
            </template> -->
          </el-table-column>
        </el-table>
        <div
          v-else
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <el-empty description="请先选择左侧的停车场"></el-empty>
        </div>
      </div>
    </div>

    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      title="预约详情"
      :visible.sync="dialogFormVisible"
      width="980px"
      @closed="closeFormDialog"
    >
      <el-descriptions :column="4" border size="medium" direction="vertical">
        <el-descriptions-item label="停车场名称" :span="1">
          {{ currentRecord.parkingName }}
        </el-descriptions-item>
        <el-descriptions-item label="停车场地址" :span="2">
          {{ currentRecord.parkingAddress }}
        </el-descriptions-item>
        <el-descriptions-item label="预约下单时间">
          {{ currentRecord.createTime }}
        </el-descriptions-item>

        <!-- -------------------------------------------------- -->
        <el-descriptions-item label="车牌号码">
          {{ currentRecord.plateNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="共享车位号">
          {{ currentRecord.uniqueId }}
        </el-descriptions-item>
        <el-descriptions-item label="预约进场时间">
          {{ currentRecord.bookIn }}
        </el-descriptions-item>
        <el-descriptions-item label="预约出场时间">
          {{ currentRecord.bookOut }}
        </el-descriptions-item>

        <!-- -------------------------------------------------- -->
        <el-descriptions-item label="实际进场时间">
          {{ utils.getOrDefault(currentRecord.actualIn, "-") }}
        </el-descriptions-item>
        <el-descriptions-item label="实际出场时间">
          {{ utils.getOrDefault(currentRecord.actualOut, "-") }}
        </el-descriptions-item>
        <el-descriptions-item label="停放时长">
          {{ utils.getOrDefault(currentRecord.duration, "-") }}
        </el-descriptions-item>
        <el-descriptions-item label="预约状态">
          {{ currentRecord.statusText }}
        </el-descriptions-item>
      </el-descriptions>

      <template v-if="recordOrders && recordOrders.length > 0">
        <el-descriptions
          v-for="(item, index) of recordOrders"
          :title="'支付订单详情' + (index + 1) + '-' + item.statusText"
          :key="index"
          :column="4"
          border
          size="medium"
          direction="vertical"
        >
          <el-descriptions-item label="订单编号" :span="1">
            {{ utils.getOrDefault(item.orderNum, "-") }}
          </el-descriptions-item>
          <el-descriptions-item label="第三方流水号" :span="1">
            {{ utils.getOrDefault(item.transactionId, "-") }}
          </el-descriptions-item>
          <el-descriptions-item label="订单状态" :span="1">
            {{ utils.getOrDefault(item.statusText, "-") }}
          </el-descriptions-item>
          <el-descriptions-item label="支付时间">
            {{ utils.getOrDefault(item.payedTime, "-") }}
          </el-descriptions-item>

          <!-- -------------------------------------------------- -->
          <el-descriptions-item label="订单金额">
            {{ utils.getOrDefault(item.amount, "-", "", "元") }}
          </el-descriptions-item>
          <el-descriptions-item label="实际支付金额">
            {{ utils.getOrDefault(item.actualAmount, "-", "", "元") }}
          </el-descriptions-item>
          <el-descriptions-item label="支付类型">
            {{ utils.getOrDefault(item.payTypeText, "-") }}
          </el-descriptions-item>
          <el-descriptions-item label="支付通道">
            {{ utils.getOrDefault(item.payChannelText, "-") }}
          </el-descriptions-item>

          <!-- -------------------------------------------------- -->
          <el-descriptions-item label="超时离场">
            {{ utils.getOrDefault(item.isOvertimeText, "-") }}
          </el-descriptions-item>
          <el-descriptions-item label="分账状态">
            {{ utils.getOrDefault(item.profitedText, "-") }}
          </el-descriptions-item>
        </el-descriptions>
      </template>

      <template v-if="orderProfit.length > 0">
        <el-divider>分账记录</el-divider>
        <el-table :data="orderProfit" border style="width: 100%">
          <el-table-column prop="uniqueId" label="共享车位号">
          </el-table-column>
          <el-table-column prop="payeeTypeText" label="分账人类型">
          </el-table-column>
          <el-table-column prop="profitTypeText" label="分账类型">
          </el-table-column>
          <el-table-column prop="typeValue" label="分账类型值">
          </el-table-column>
          <el-table-column prop="actualAmount" label="实付金额">
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.actualAmount, "-", "", "元") }}
            </template>
          </el-table-column>
          <el-table-column prop="profitAmount" label="分账金额">
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.profitAmount, "-", "", "元") }}
            </template>
          </el-table-column>

          <el-table-column prop="statusText" label="分账状态">
          </el-table-column>
          <el-table-column prop="createTime" label="分账时间" width="150">
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  shareParks,
  bookRecord,
  bookOrderProfit,
  shareRecordAllOrders,
} from "@/api/url";

import * as utils from "@/utils/utils";

import Page from "@/page/commons/page";
// import AreaTree from "@/page/commons/parking/commons/areaTree.vue";
import shareParkingTree from "@/page/commons/parking/commons/share-parking-tree.vue";

export default {
  data() {
    return {
      parks: [],

      status: {
        1: "新建预约",
        2: "免费取消",
        3: "已完成",
        4: "预约未进场",
        5: "预约已进场",
        6: "超时未进场已取消",
        7: "超时取消",
        8: "超时未出场",
        9: "超时未支付已取消",
      },

      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        parkingId: undefined,
        uniqueId: "",
        plateNumber: "",
        status: "",
        orderNum: undefined,
      },
      tableListData: {
        rows: [],
      },
      formLabelWidth: "100px",
      dialogFormVisible: false,
      currentRecord: {},
      orderProfit: [],
      recordOrders: [],
      utils,
      tableLoading: false,
      dialogLoading: false,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage, id) {
      var _this = this;
      _this.tableLoading = true;
      _this.tableListData.rows = [];
      const { parkingId, uniqueId, plateNumber, status } = this.search;
      const param = { orderNum: this.search.orderNum };
      if (parkingId) {
        param.parkingId = parkingId;
      }
      if (uniqueId) {
        param.uniqueId = uniqueId;
      }
      if (plateNumber) {
        param.plateNumber = plateNumber;
      }
      if (status) {
        param.status = status;
      }
      this.$get(bookRecord(), {
        limit: this.search.pageSize,
        page: curPage,
        ...param,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页

          var rows = data.data.rows;

          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData.rows = data.data.rows.map((record) => {
            return record;
          });
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    searchList: function () {
      if (!this.search.parkingId)
        return this.$message({ type: "error", message: "请先选择停车场" });

      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },

    getShareParks() {
      return this.$postRequest(shareParks(), {}).then((res) => {
        this.parks = res?.data?.data?.rows ?? [];
      });
    },

    async handleRecordDetail(row) {
      try {
        this.currentRecord = row;
        this.dialogFormVisible = true;
        this.dialogLoading = true;

        let data = await this.$get(shareRecordAllOrders(row.id));
        if (data.data.length > 0) this.recordOrders = data.data;

        data = await this.$get(bookOrderProfit(row.id));
        if (data.data.length > 0) this.orderProfit = data.data;
      } finally {
        this.dialogLoading = false;
      }
    },
    closeFormDialog() {
      this.dialogFormVisible = false;
      this.currentRecord = {};
      this.orderProfit = [];
      this.recordOrders = [];
    },
    handleTreeClick: function (node) {
      // 如果节点类型为停车场
      if (node.type === "parking") {
        this.search.parkingId = node.id;
        // 获取数据
        this.tableList(this.search.pageNumber);
      } else this.search.parkingId = undefined;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
    shareParkingTree,
  },

  mounted: function () {
    // this.getShareParks();

    this.search.pageNumber = 1;
    // this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.boxbgcolor {
  width: 100%;
  display: flex;
}

.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}

.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.searchbox {
  background: #f9f9fb;
  /* height:130px;
            line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}

.form-inline {
  display: flex;

  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}

.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}

.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}

.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}

.intellidata-device-iorecord img {
  display: inline-block;
  margin-right: 2px;
}

::v-deep .el-descriptions__header {
  margin-top: 10px;
  margin-bottom: 5px;
}
</style>
